export default __webpack_public_path__ + "static/media/Declaration of Independence_07.3b8207c8.jpg";